import EmblaCarousel from 'embla-carousel';

export default function ProductCarousel() {
  let emblaApiMain;
  let emblaApiThumbnail;
  const viewportNodeMainCarousel = document.querySelector('.product-viewport');
  const viewportNodeThumbCarousel = document.querySelector('.product-thumbnail__viewport');
  const carouselPagination = document.querySelectorAll('.product-dotted__button');
  const productThumbnailSlides = document.querySelectorAll('.product-thumbnail__slide');
  const leftButton = document.querySelector('.product-left__button');
  const rightButton = document.querySelector('.product-right__button');
  const defaultIndex = document.querySelector('.product-thumbnail__viewport').dataset.defaultIndex;
  let firstTimeUrl = document.URL;

  function thumbnailButtonsHandler() {
    const slidesThumbs = emblaApiThumbnail.slideNodes();

    const scrollToIndex = slidesThumbs.map((_, index) => () => emblaApiMain.scrollTo(index));

    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener('click', scrollToIndex[index], false);
    });

    return () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener('click', scrollToIndex[index], false);
      });
    };
  }

  function onToggleSelectedPagination(embla) {
    carouselPagination[defaultIndex - 1].classList.remove('--is-active');
    const previous = embla.previousScrollSnap();
    const selected = embla.selectedScrollSnap();
    carouselPagination[previous].classList.remove('--is-active');
    carouselPagination[selected].classList.add('--is-active');
  }

  function onScrollToIndex(index) {
    emblaApiThumbnail.scrollTo(index);
    onToggleSelectedPagination(emblaApiThumbnail);
  }

  function paginationClickHandler() {
    carouselPagination.forEach((pagination, index) => {
      pagination.classList.remove('--is-active');
      if (defaultIndex - 1 === index) {
        pagination.classList.add('--is-active');
      }
      pagination.addEventListener('click', () => onScrollToIndex(index), false);
    });

    emblaApiThumbnail
      .on('reInit', () => onToggleSelectedPagination(emblaApiThumbnail))
      .on('select', () => onToggleSelectedPagination(emblaApiThumbnail));

    return () => {
      carouselPagination.forEach((pagination, index) => {
        pagination.removeEventListener('click', () => onScrollToIndex(index, emblaApiThumbnail), false);
      });
    };
  }

  function onApplyOpacity(emblaApi) {
    const previousIndex = emblaApi.previousScrollSnap();
    const currentIndex = emblaApi.selectedScrollSnap();
    const slides = emblaApi.slideNodes();
    slides[previousIndex].classList.remove('--is-visible');
    slides[currentIndex].classList.add('--is-visible');
  }

  function toggleThumbnailsState() {
    const thumbnailSlidesToScroll = window.innerWidth > 768 ? 4 : 1;
    const toggleThumbBtnsState = () => {
      emblaApiThumbnail.scrollTo(Math.floor(emblaApiMain.selectedScrollSnap() / thumbnailSlidesToScroll));
    };

    emblaApiMain.on('select', toggleThumbBtnsState);
    emblaApiThumbnail.on('init', toggleThumbBtnsState);
  }

  function onMoveLeft() {
    if (emblaApiThumbnail.canScrollPrev()) {
      emblaApiThumbnail.scrollPrev();
    }
    return null;
  }

  function onMoveRight() {
    if (emblaApiThumbnail.canScrollNext()) {
      emblaApiThumbnail.scrollNext();
    }
    return null;
  }

  function addNavigationButtonHandler() {
    if (leftButton) {
      leftButton.addEventListener('click', onMoveLeft);
    }

    if (rightButton) {
      rightButton.addEventListener('click', onMoveRight);
    }

    return () => {
      leftButton.removeEventListener('click', onMoveLeft);
      rightButton.removeEventListener('click', onMoveRight);
    };
  }

  function onUpdateMedia(isVariantUrl) {
    if (isVariantUrl) {
      for (let i = 0; i < productThumbnailSlides.length; i++) {
        const isVariantAvailable = productThumbnailSlides[i].dataset.variantId === isVariantUrl;
        if (isVariantAvailable) {
          if (window.innerWidth > 768) {
            emblaApiMain.scrollTo(i);
          } else {
            emblaApiThumbnail.scrollTo(i);
          }
        }
      }
    }
    return null;
  }

  function onUrlChangeCallback() {
    let currentPageUrl = document.URL;
    const url = new URL(currentPageUrl);
    const isVariantUrl = url.searchParams.get('variant');
    currentPageUrl = isVariantUrl ? currentPageUrl : isVariantUrl;
    if (currentPageUrl && firstTimeUrl !== currentPageUrl) {
      firstTimeUrl = currentPageUrl;
      onUpdateMedia(isVariantUrl);
    }
  }

  function onUpdateVariant(emblaApi) {
    const element = document.querySelector('variant-radios');
    const beadsWrapper = document.querySelector('.product-form__input');
    const fieldsets = beadsWrapper.querySelectorAll('input');
    const previousInput = fieldsets[emblaApi.previousScrollSnap()];
    const selectedInput = fieldsets[emblaApi.selectedScrollSnap()];
    previousInput.checked = false;
    selectedInput.checked = true;
    const evt = new Event('change');
    element.dispatchEvent(evt);
  }

  function init() {
    const options = {
      align: 'center',
      containScroll: 'trimSnaps',
      skipSnaps: true,
      startIndex: defaultIndex - 1,
      loop: true,
      watchResize: true,
    };
    const optionsThumbnail = {
      containScroll: 'trimSnaps',
      align: 'start',
      loop: false,
      slidesToScroll: 4,
      startIndex: Math.floor((defaultIndex - 1) / 4),
      watchResize: true,
      breakpoints: {
        '(max-width: 768px)': {
          align: 'center',
          loop: true,
          skipSnaps: true,
          slidesToScroll: 1,
          startIndex: defaultIndex - 1,
        },
      },
    };

    // Embla context
    emblaApiMain = EmblaCarousel && EmblaCarousel(viewportNodeMainCarousel, options);
    emblaApiThumbnail = EmblaCarousel && EmblaCarousel(viewportNodeThumbCarousel, optionsThumbnail);

    const removeThumbnailButtonHandlers = viewportNodeThumbCarousel && thumbnailButtonsHandler();

    if (viewportNodeThumbCarousel) {
      toggleThumbnailsState();
    }

    const removeNavigationButtonHandler = addNavigationButtonHandler();

    emblaApiMain
      .on('init', onApplyOpacity)
      .on('reInit', onApplyOpacity)
      .on('select', onApplyOpacity)
      .on('select', onUpdateVariant);

    emblaApiThumbnail
      .on('init', onApplyOpacity)
      .on('reInit', onApplyOpacity)
      .on('reInit', paginationClickHandler)
      .on('select', onApplyOpacity);

    if (window.innerWidth <= 769) {
      emblaApiThumbnail
        .on('init', paginationClickHandler)
        .on('reInit', paginationClickHandler)
        .on('select', onUpdateVariant);
    } else {
      emblaApiThumbnail
        .off('init', paginationClickHandler)
        .off('reInit', paginationClickHandler)
        .off('select', onUpdateVariant);
    }

    document.addEventListener('change', onUrlChangeCallback);

    emblaApiMain.on('destroy', removeThumbnailButtonHandlers);

    emblaApiThumbnail
      .on('init', () => {
        if (window.innerWidth < 768) {
          emblaApiThumbnail.scrollTo(defaultIndex - 1);
        }
      })
      .on('destroy', removeThumbnailButtonHandlers)
      .on('destroy', removeNavigationButtonHandler);
  }

  if (
    document.body.classList.contains('template-product-bracelets') ||
    document.body.classList.contains('template-product-bracelets-pwyw')
  ) {
    init();
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 769) {
        emblaApiThumbnail
          .on('init', paginationClickHandler)
          .on('reInit', paginationClickHandler)
          .on('select', onUpdateVariant);
      } else {
        emblaApiThumbnail
          .off('init', paginationClickHandler)
          .off('reInit', paginationClickHandler)
          .off('select', onUpdateVariant);
      }
    });
  }
}
